import { Plus } from 'iconoir-react';
import { FC } from 'react';

import { safeFormattedIntlString } from '@savgroup-front-common/core/formatters';
import { cn } from '@savgroup-front-common/primitive/lib/utils';
import { Button } from '@savgroup-front-common/primitive/ui/button';

import { CreateActionDrawer } from '../../../CreateButton/CreateActionDrawer/CreateActionDrawer';
import CreateModal from '../../../CreateButton/CreateModal';
import useCreateButton from '../../../CreateButton/hooks/useCreateButton';

import messages from './messages';

export const BottomBarCreateAction: FC = () => {
  const {
    onCreateModalClose,
    onToggleMenu,
    isMenuOpen,
    modalType,
    handleButtonClick,
    authorizedOptions,
    hasMultipleOptions,
    isDisabled,
    isOnlySparePartRequest,
  } = useCreateButton();

  const label = safeFormattedIntlString(
    isOnlySparePartRequest ? messages.sparePartRequest : messages.createLabel,
  );

  const onCreateClick = hasMultipleOptions
    ? () => onToggleMenu()
    : handleButtonClick;
  const ariaExpanded = hasMultipleOptions ? isMenuOpen : undefined;

  return (
    <div className="flex min-w-0 flex-col items-center gap-1">
      {!isDisabled && (
        <>
          <Button
            aria-label={label}
            aria-expanded={ariaExpanded}
            onClick={onCreateClick}
            className={cn(
              '-mt-7.5 size-15 rounded-full border-4 border-surface-base-default',
              'shadow-lg shadow-surface-primary-default/35',
            )}
            data-testid="appBarBottomBar_create"
          >
            <Plus className="size-6" />
          </Button>

          <span
            aria-hidden
            className="stext-primary-default max-w-full truncate text-xs font-semibold"
          >
            {label}
          </span>

          {hasMultipleOptions && (
            <CreateActionDrawer
              isOpen={isMenuOpen}
              onOpenChange={onToggleMenu}
              label={label}
              authorizedOptions={authorizedOptions}
            />
          )}
        </>
      )}

      <CreateModal onClose={onCreateModalClose} modalType={modalType} />
    </div>
  );
};
